import { render, staticRenderFns } from "./RolesTableItem.vue?vue&type=template&id=3d2cc98e&scoped=true&"
import script from "./RolesTableItem.vue?vue&type=script&lang=js&"
export * from "./RolesTableItem.vue?vue&type=script&lang=js&"
import style0 from "./RolesTableItem.vue?vue&type=style&index=0&id=3d2cc98e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2cc98e",
  null
  
)

export default component.exports